import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  itemWrapper: {
    display: "flex",
    flexDirection: "row",
    fontSize: '12px !important',
  },
  itemImageWrapper: {
    display: "flex",
    borderRadius: "5px",
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
    height: "16px",
    width: "16px",
    marginRight: "10px",
    position: "relative",
    top: "2px"
  },
  itemImage: {
    height: "100%",
    width: "100%"
  },

}));

export default useStyles;
